import SummaryTable from './summary-table';

export default SummaryTable;
